import {useNavigate} from 'react-router-dom'

function CircuitPost({
  search,
  currentPosts,
  checkedControl,
  handleChecked,
  setEditData,
  page,
  rowsPerPage,
  row,
}: any) {
  const navigate = useNavigate()

  return search(currentPosts)?.map((item: any, index: any) => (
    <tr key={index}>
      <td>
        <input
          className='form-check-input'
          type='checkbox'
          value={item.id}
          checked={checkedControl(String(item.id))}
          onChange={(e) => (handleChecked(e), setEditData(item))}
        />
      </td>
      <td>{item.id}</td>
      <td>
        <a
          style={{cursor: 'pointer'}}
          className=' link-primary'
          /*
          onClick={
            () =>
              navigate(`/management/experiment/selected-experiment/selected-circuit`, {
                state: {item, row, page, rowsPerPage},
              })
            //  window.localStorage.setItem('circuitData', JSON.stringify(item))
          }*/
          onClick={
            () =>
              navigate(`/management/experiment/${row.id}/${item.id}`, {
                state: {item, row, page, rowsPerPage},
              })
            //  window.localStorage.setItem('circuitData', JSON.stringify(item))
          }
        >
          {item.name}
        </a>
      </td>
      <td>{item.description}</td>
    </tr>
  ))
}

export default CircuitPost
